import { render, staticRenderFns } from "./SmartBanner.vue?vue&type=template&id=3a4427a2&scoped=true&"
import script from "./SmartBanner.vue?vue&type=script&lang=js&"
export * from "./SmartBanner.vue?vue&type=script&lang=js&"
import style0 from "./SmartBanner.vue?vue&type=style&index=0&id=3a4427a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4427a2",
  null
  
)

export default component.exports